import { render, staticRenderFns } from "./SearchResponsesItemChatText.vue?vue&type=template&id=7f7d878b&scoped=true"
import script from "./SearchResponsesItemChatText.vue?vue&type=script&lang=js"
export * from "./SearchResponsesItemChatText.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesItemChatText.vue?vue&type=style&index=0&id=7f7d878b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d878b",
  null
  
)

export default component.exports